<template>
	<div id="processInfo">



		<el-dialog class='gDia' :title="$t('lin_global.shebeiedit')" :show-close='true' v-model="processInfoVisible"
			:modal="true" size="small" lock-scroll close-on-press-escape @close="closeDialog"
			:close-on-click-modal="false">

			<el-form ref="addForm" id="addForm" :model="form" :rules="rules" label-width="150px">
				<el-popover ref="popover1" placement="right-end" width="225" trigger="hover"
					:content="$t('terminal.add.popover_no')" popper-class=""></el-popover>
				<el-form-item :label="$t('lin_global.label_no')" prop="terminal_no">
					<el-input id="terminal_no" v-popover:popover1 v-model="form.terminal_no" :maxlength="50"
						:placeholder="$t('terminal.add.place_no')"></el-input>
				</el-form-item>
				<el-popover ref="popover2" placement="right-end" width="225" trigger="hover"
					:content="$t('terminal.add.popover_name')" popper-class=""></el-popover>
				<el-form-item :label="$t('lin_global.label_name')" prop="terminal_name">
					<el-input id="terminal_name" v-popover:popover2 v-model="form.terminal_name" :maxlength="50"
						:placeholder="$t('terminal.add.place_name')"></el-input>
				</el-form-item>

				<el-form-item :label="$t('lin_global.label_areaid')" prop="areaid">

					<MechanismSelector :data="mechanismData" :mselect="true"></MechanismSelector>
				</el-form-item>

				<el-form-item :label="$t('lin_global.label_model')" prop="terminal_model">
					<el-select id="terminal_model" v-model="form.terminal_model" filterable clearable
						:placeholder="$t('terminal.add.place_model')" class="">
						<el-option v-for="item in models" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<!-- <el-cascader
            expand-trigger="hover"
            :options="models"
            :show-all-levels="false"
            v-model="form.terminal_model"
          ></el-cascader> -->
				</el-form-item>
				<el-form-item :label="$t('lin_global.label_type')" prop="terminal_type">
					<el-select id="terminal_type" v-model="form.terminal_type" filterable clearable
						:placeholder="$t('terminal.add.place_type')" class="">
						<el-option v-for="item in dvTypes" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<!-- <el-cascader
            expand-trigger="hover"
            :options="dvTypes"
            :show-all-levels="false"
            v-model="form.terminal_type"
          ></el-cascader> -->
				</el-form-item>
				<el-form-item :label="$t('lin_global.label_manufid')" prop="manufid">
					<el-select id="terminal_type" v-model="form.manufid" filterable clearable
						:placeholder="$t('terminal.add.place_manufid')" class="">
						<el-option v-for="item in firms" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<!-- <el-cascader
            expand-trigger="hover"
            :options="firms"
            :show-all-levels="false"
            v-model="form.manufid"
          ></el-cascader> -->
				</el-form-item>

				<el-form-item :label="$t('lin_global.label_address')" prop="address">
					<el-input id="address" v-model="form.address"
						:placeholder="$t('terminal.add.place_address')"></el-input>
				</el-form-item>
				
				<!-- <el-form-item :label="$t('terminal.list.ac_time')" prop="terminalCreateTime">
					<el-date-picker   v-model="form.terminalCreateTime"  @change="ac_date"
						type="datetime" :placeholder="$t('terminal.add.place_actime')"  >
					</el-date-picker>
				
				</el-form-item> -->
				<!-- <el-form-item :label="$t('terminal.list.ec_time')" prop="expirationTime">
					<el-date-picker   v-model="form.expirationTime"  @change="ex_date"
						type="datetime" :placeholder="$t('terminal.add.place_extime')"  >
					</el-date-picker>
				</el-form-item> -->
				
				
				<el-form-item :label="$t('lin_global.remark')" prop="memo">
					<el-input id="memo" v-model="form.memo" :placeholder="$t('lin_global.remark')"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="onCancel" id="onCancel" :disabled='isSubmit'>{{$t('lin_btn.cancel')}}</el-button>
					<el-button type="primary" @click="onSubmit" :loading="isSubmit"
						id="onSubmit">{{$t('lin_btn.change')}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>


	</div>
</template>
<script>
	import axios from 'axios'
	import {
		baseurl
	} from '../../api/url'
	import jq from 'jquery'
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import {
		isNull
	} from 'util';
	// import { isNull } from 'util';
	export default {
		components: {
			MechanismSelector
		},
		name: 'processInfo',
		data() {
			var terNoCheck = (rule, value, callback) => {
				var token = localStorage.getItem('user');
				var params = {
					token: token,
					terminal_no: value
				}
				if (this.pdata.terminalNO !== value) {
					axios.post(`${baseurl}/terminal/existTerNo.do`, params).then(res => {
						console.log(res.data);
						if (res.data.status == '200') {
							if (res.data.data.existTerminal) {
								callback(new Error(this.$t('terminal.add.rules_no_4')));
							} else {
								callback();
							}
						} else {

						}
					})
				} else if (this.pdata.terminalNO == value) {
					callback();
				} else {
					callback();
				}

			};
			var that = this
			return {
				mechanismData: '',
				models: [],
				dvTypes: [],
				firms: [],
				isSubmit: false,
				processInfoVisible: true,

				form: {
					'terminal_id': this.pdata.terminalID,
					'terminal_no': null,
					'terminal_name': null,
					'terminal_model': null,
					'terminal_type': null,
					'areaid': null,
					'manufid': null,
					'address': null,
					// 'terminalCreateTime':null,
					// 'expirationTime':null,
					'memo': ''
				},
				rules: {
					'terminal_no': [{
						type: 'string',
						required: true,
						message: this.$t('terminal.add.rules_no_1')
					}, {
						min: 1,
						max: 50,
						message: this.$t('terminal.add.rules_no_2')
					}, {
						pattern: /^[\w-]+$/,
						message: this.$t('terminal.add.rules_no_3')
					}, {
						validator: terNoCheck,
						trigger: 'blur'
					}],
					'terminal_name': [{
							type: 'string',
							required: true,
							message: this.$t('terminal.add.rules_name_1')
						}
						/*, {
						            min: 1,
						            max: 30,
						            message:  this.$t('terminal.add.rules_name_2')
						          }, {
						            pattern: /^[\w\u4e00-\u9fa5\d]+$/,
						            message: this.$t('terminal.add.rules_name_3')
						          }*/
					],
					'terminal_model': [{
						required: true,
						message: this.$t('terminal.add.place_model')
					}],
					'terminal_type': [{
						required: true,
						message: this.$t('terminal.add.place_type')
					}],
					'manufid': [{
						required: true,
						message: this.$t('terminal.add.place_manufid')
					}],
					'areaid': [{
						required: true,
						message: this.$t('lin_global.place_areaid')
					}],
					'address': [{
						required: true,
						message: this.$t('terminal.add.place_address')
					}],
					// 'terminalCreateTime': [{
					// 	required: true,
					// 	message: this.$t('terminal.add.place_actime')
					// }],
					// 'expirationTime': [{
					// 	required: true,
					// 	message: this.$t('terminal.add.place_extime')
					// }],
				},
				vendorList: [],
				modelList: [],
				terminalTypeList: [],
				areaList: []
			}
		},
		props: ['pdata'],
		created() {

			// this.$gpDvModel('', (res) => {
			// 	this.models = res.data
			// 	console.log(this.models)
			// }, '') 

			// setTimeout(() => {
			//   this.$gpDvType('', (res) => {
			//     this.dvTypes = res.data
			//   }, '') 
			// }, 100)

			// setTimeout(() => {
			//   this.$gpFirm('', (res) => {
			//     this.firms = res.data
			//   }, '')
			// }, 100)


			this.fetchData();
			//this.getVendor();
			//this.getAd();
		},
		methods: {
			// 激活时间
			// ac_date() {
			// 	let start_time = this.dateFormat(this.form.terminalCreateTime) 
			// 	this.form.terminalCreateTime = start_time;
			// },
			// // 过期时间
			// ex_date() {
			// 	let end_time = this.dateFormat(this.form.expirationTime)
			// 	this.form.expirationTime = end_time;
			// },
			// 日期格式化
			dateFormat(dateData) {
				var date = new Date(dateData)
				var y = date.getFullYear()
				var m = date.getMonth() + 1
				m = m < 10 ? ('0' + m) : m
				var d = date.getDate()
				d = d < 10 ? ('0' + d) : d
			
			
				var hh = date.getHours()
				hh = hh < 10 ? ('0' + hh) : hh
			
				var mm = date.getMinutes()
				mm = mm < 10 ? ('0' + mm) : mm
			
				var ss = date.getSeconds()
				ss = ss < 10 ? ('0' + ss) : ss
			
				const time = y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ":" + ss
				return time
			},
			
			
			getSlData(value) {
				if (!value) {
					this.models = []
					this.dvTypes = []
					this.firms = []
					return
				}
				this.$mechGetTypes(value, res => {
					if (res.status == 200) {
						this.models = res.data.models
						this.dvTypes = res.data.types
						this.firms = res.data.manufactures
					}
				}, '')
			},
			closeDialog: function() {
				this.$parent.processInfoVisible = false
				// this.processInfoVisible = false;
			},
			/*testChange () {
			 console.log('/////set')
			 this.$store.dispatch('setEditChange','true')
			 this.pdata.isChange = this.$store.getters.edit_change

			 console.log(this.$store.getters.edit_change)
			 },*/
			addInfo: function() {

				let jsondata = {}
				jsondata = this.form
				//console.log('添加的数据为：' + JSON.stringify(jsondata))
				this.isSubmit = true;

				var newJson = jq.extend(true, {}, this.form)
				newJson.terminal_model = this.form.terminal_model
				newJson.terminal_type = this.form.terminal_type
				newJson.manufid = this.form.manufid



				axios.post(`${baseurl}/terminal/edit.do`, newJson).then(res => {
					//console.log(res.data);

					if (res.data.status == '200') {

						this.$message.success(this.$t('terminal.add.change_success'))
						this.processInfoVisible = false;
						//this.pdata.pdataFinsh = 'true';
						if (this.$store.getters.edit_change) {
							this.$store.dispatch('setEditChange', false)
							this.pdata.isChange = this.$store.getters.edit_change
						} else {
							this.$store.dispatch('setEditChange', true)
							this.pdata.isChange = this.$store.getters.edit_change

						}

						//this.pdata.isChange = this.$store.getters.edit_change
					} else {
						this.isSubmit = false
						//console.log(res.data.message)
						this.$message.error(res.data.message)
					}
				})
			},
			onSubmit: function() {
				this.$refs['addForm'].validate((valid) => {
					if (valid) {
						this.addInfo()
					} else {
						this.$message.error(this.$t('lin_global.refs'))
						return false
					}
				})
			},
			onCancel: function() {
				this.processInfoVisible = false;
			},
			getVendor: function() {
				var params = {
					page: 1,
					rows: 10000
				};
				axios.post(`${baseurl}/manufacturers/list.do`, params).then(res => {
					//console.log(res.data);
					this.vendorList = res.data.data;
				})
			},
			getType: function() {
				var params = {
					page: 1,
					rows: 10000
				};
				axios.post(`${baseurl}/terminalType/list.do`, params).then(res => {
					//console.log(res.data);
					this.terminalTypeList = res.data.data;
				})
			},
			getAd: function() {

				var params = {
					page: 1,
					rows: 10000
				};
				axios.post(`${baseurl}/mechanism/list.do`, params).then(res => {
					//console.log("打印返回渠道商列表")
					//console.log(res.data);
					this.areaList = res.data.data;
				})
			},
			fetchData: function() {

				this.processInfoVisible = true;
				// console.log('pdata', this.pdata)
				this.form.terminal_no = this.pdata.terminalNO;
				this.form.terminal_name = this.pdata.terminal_name;
				this.form.address = this.pdata.address;
				this.form.areaid = this.pdata.areaid;

				this.form.manufid = this.pdata.manufid[1];
				this.form.terminal_type = this.pdata.terminal_type[1];
				this.form.terminal_model = this.pdata.terminal_model[1];

				// this.form.terminalCreateTime = this.pdata.terminalCreateTime
				// this.form.expirationTime = this.pdata.expirationTime
				this.form.memo = this.pdata.memo
				//console.log('pd', this.pdata)
				console.log(this.pdata)

				var that = this
				this.mechanismData = {
					value: that.pdata.mechanismName,
					callback(value) {
						that.form.areaid = value
						that.form.terminal_model = ''
						that.form.terminal_type = ''
						that.form.manufid = ''
						that.getSlData(value)
					}
				}

				this.$mechGetTypes(this.form.areaid, res => {
					if (res.status == 200) {
						this.models = res.data.models
						this.dvTypes = res.data.types
						this.firms = res.data.manufactures
					}
				}, '')


			},
			getModel: function() {
				var params = {
					page: 1,
					rows: 10000
				};
				axios.post(`${baseurl}/terminalModel/list.do`, params).then(res => {
					//console.log(res.data);
					this.modelList = res.data.data;
				})
			}
		}
	}
</script>
<style scoped>


</style>


// WEBPACK FOOTER //
// processInfo.vue?b363a816